import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
/**
 * Send update object events.
 *
 * @param objectId {string}
 * @param objectTypeId {string}
 * @returns {object} {sendUpdateObjectMessage}
 */
export function useCRMUpdateObject({
  objectId,
  objectTypeId
}) {
  const sendUpdateObjectMessage = useSendCrmMessageTopic('UPDATE_OBJECT');
  function handleUpdateObject(propertyNames) {
    sendUpdateObjectMessage({
      objectId,
      objectTypeId,
      propertyNames
    });
  }
  return {
    sendUpdateObjectMessage: handleUpdateObject
  };
}